import React from 'react';
import '../LandingPage.css'; // Assuming styles are still here
import aboutImage from '../../assets/about-tech.jpg';

function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="section-content">
        <h2>About EFSoft</h2>
        <div className="about-grid">
          <div className="about-text">
            <p>We are a software engineering company with over 20 years of experience developing web applications using various technologies. We have worked on several projects in different industries such as healthcare, finance, and e-commerce.</p>
          </div>
          <div className="about-image">
            <img
              src={aboutImage}
              alt="Software development and technology illustration"
              className="tech-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
